<template>
  <div :id="picOption.id" class="pic-box"></div>
</template>

<script>
import echarts from 'echarts'

export default {
  props: {
    picOption: {
      type: Object,
      default: () => {
        return {
          callback: () => {
          },
          id: '',
          charsOption: {}
        }
      }
    }
  },
  data() {
    return {
      myChart: null
    }
  },
  methods: {
    drawpic() {
      if (!this.myChart)
        this.myChart = echarts.init(document.getElementById(this.picOption.id));
      this.myChart.clear();
      this.myChart.setOption(this.picOption.charsOption);
      this.myChart.on("click", this.picOption.callback);
    },
    pushDataLeftTopPic() {
      this.myChart.setOption(this.picOption.charsOption);
    }


  }
}

</script>

<style>
.pic-box {
  height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/controls/echarts.vue